import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack, useSnackbarStack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { Form, FormikProvider } from 'formik';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useAppFormik } from 'shared/form/AppFormik';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { driverEditLegacySchema } from 'shared/modules/driver/DriverDTO';
import { useDriver, useDriversAPI } from '../../drivers/data/DriversAPI';
import { DriverFormFields } from 'shared/modules/driver/DriverFormFields';

function DriverInfoContainer({ guid }: { guid: string }) {
  const { data } = useDriver(guid);
  const { addSnackbar } = useSnackbarStack();

  const { patchDriver } = useDriversAPI();
  const formik = useAppFormik({
    initialValues: data,
    validationSchema: driverEditLegacySchema,
    onSubmit(values) {
      return patchDriver(guid, values, data);
    },
    onSubmitSuccess() {
      MobileAppBridge.sendDriverUpdatedEvent();
    },
    onSubmitFailure(error) {
      addSnackbar(error.message, { variant: 'error' });
    },
  });

  useDocumentTitle('Personal Info');

  const hasWarning = !!data?.has_dispatcher;

  return (
    <WebviewLayout backgroundColor={ColorDynamic.White}>
      <FormikProvider value={formik}>
        <Form>
          <Box padding="small" maxWidth="400px" margin="auto">
            <Stack space="large">
              <DriverFormFields type="edit" hasWarning={hasWarning} />
              <Button fullWidth={true} type="submit" disabled={!formik.dirty}>
                Save
              </Button>
            </Stack>
          </Box>
        </Form>
      </FormikProvider>
    </WebviewLayout>
  );
}

export function DriverInfoPage() {
  const guid = MobileAppBridge.getDriverGuid();

  if (!guid) {
    return (
      <Box marginTop="large">
        <Typography align="center" color="textSecondary" variant="h3">
          Driver guid is not defined
        </Typography>
      </Box>
    );
  }

  return <DriverInfoContainer guid={guid} />;
}
